// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__-q3bZ","flag":"style_flag__EHsr+","menuIcon":"style_menuIcon__R49Xu"};